import React from 'react';

import styled from 'styled-components';

interface Props {
  secondary: React.ReactNode;
  secondaryZindex?: string;
  children: React.ReactNode;
  mainZindex?: string;
  scrollable?: boolean;
  mainContentClass?: string;
  type: 'horizontal' | 'vertical';
}

export const FlexPanel = ({
  children,
  secondary,
  type,
  scrollable = false,
  mainContentClass = '',
  secondaryZindex = '1',
  ...other
}: Props): JSX.Element => (
  <StyledFlexPanelDiv
    type={type}
    scrollable={scrollable}
    secondaryZindex={secondaryZindex}
    {...other}
  >
    <div className="secondary">{secondary}</div>
    <div className={`main ${mainContentClass}`}>{children}</div>
  </StyledFlexPanelDiv>
);

type StyledFlexPanelDivProps = Pick<
  Props,
  'type' | 'secondaryZindex' | 'scrollable' | 'mainZindex'
>;

const StyledFlexPanelDiv = styled.div.attrs<StyledFlexPanelDivProps>({
  className: 'print-overflow-force',
})<StyledFlexPanelDivProps>`
  flex-grow: 1;
  display: flex;
  flex-direction: ${({type}) => (type === 'vertical' ? 'column' : 'row')};
  align-items: stretch;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  > .secondary {
    z-index: ${({secondaryZindex}) => secondaryZindex};
    flex: 0 0 0%;
    -ms-flex-preferred-size: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
  }
  > .main {
    position: relative;
    overflow: ${({scrollable}) => (scrollable === true ? 'auto' : 'hidden')};
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    flex: 1 1 auto;
    z-index: ${({mainZindex}) => mainZindex || 'auto'};
  }
`;
